import React, { useEffect, useState } from 'react';
import './css/shop-category.css';
import Item from '../components/Item';
import ItemSkeleton from '../skeletons/Item';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProducts, clearProducts } from '../redux/shopSlice';
import {
  Box,
  Container,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Button,
  Grid,
  Chip,
} from '@mui/material';
import { KeyboardArrowDown, ExpandMore, Sort } from '@mui/icons-material';
import { useParams } from 'react-router-dom';
import men_banner from '../components/assets/banner_mens.png';
import women_banner from '../components/assets/banner_women.png';
import kid_banner from '../components/assets/banner_kids.png';

const bannerMap = {
  men: men_banner,
  women: women_banner,
  kid: kid_banner,
};

const ShopCategory = (props) => {
  const dispatch = useDispatch();
  const { all_product, totalProducts, loading } = useSelector((state) => state.cart);

  const { category } = useParams();
  const [sortBy, setSortBy] = useState('default');
  const [page, setPage] = useState(1);
  const limit = 10;

  // Reset on category/sort change
  useEffect(() => {
    dispatch(clearProducts());
    setPage(1);
    dispatch(fetchProducts({ category, sortBy, page: 1, limit }));
  }, [category, sortBy, dispatch]);

  const handleSortChange = (event) => {
    setSortBy(event.target.value);
  };

  const handleLoadMore = () => {
    if (loading) return;

    const nextPage = page + 1;
    setPage(nextPage);
    dispatch(fetchProducts({ category, sortBy, page: nextPage, limit }));
  };

  const hasMore = all_product.length < totalProducts;

  return (
    <div className="shop-category">
      {/* Banner */}
      <Box className="banner-container">
        <img className="banner-img" src={bannerMap[category]} alt={category} />
      </Box>

      <Container maxWidth="xl">
        {/* Header Section */}
        <Box className="category-header">
          <Chip
            label={
              loading && page === 1
                ? 'Loading...'
                : `Showing ${all_product.length} of ${totalProducts} products`
            }
            color="primary"
            size="medium"
            className="products-count-chip"
          />

          <Box className="sort-section">
            <Sort className="sort-icon" />
            <FormControl variant="outlined" size="small" className="sort-select">
              <Select
                value={sortBy}
                onChange={handleSortChange}
                IconComponent={KeyboardArrowDown}
                disabled={loading}
              >
                <MenuItem value="default">Default Sorting</MenuItem>
                <MenuItem value="price-low">Price: Low to High</MenuItem>
                <MenuItem value="price-high">Price: High to Low</MenuItem>
                <MenuItem value="name-asc">Name: A to Z</MenuItem>
                <MenuItem value="name-desc">Name: Z to A</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>

        {/* Products Grid */}
        <Grid container spacing={3} className="products-grid">
          {all_product.length > 0 &&
            all_product.map((item) => (
              <Grid item xs={12} sm={6} md={4} lg={2.4} key={item._id}>
                <Item
                  id={item._id}
                  image={item.primaryImage}
                  name={item.name}
                  new_price={item.new_price}
                  old_price={item.old_price}
                />
              </Grid>
            ))}

          {/* Skeletons for initial loading */}
          {loading && page === 1 && all_product.length === 0 &&
            <ItemSkeleton />
          }

          {/* Skeletons when loading more */}
          {loading && page > 1 &&
            <ItemSkeleton />
          }

        </Grid>
        {!loading && all_product.length === 0 && (
          <Grid item className="no-products-container">
            <Box className="no-products">
              <Typography variant="h5" color="textSecondary">
                No products found in this category
              </Typography>
            </Box>
          </Grid>
        )}

        {/* Load More */}
        {!loading && hasMore && (
          <Box className="load-more-container">
            <Button
              variant="contained"
              size="large"
              endIcon={<ExpandMore />}
              onClick={handleLoadMore}
              disabled={loading}
              className="load-more-btn"
            >
              Explore More Products
            </Button>
          </Box>
        )}
      </Container>
    </div>
  );
};

export default ShopCategory;